import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import { logout } from '../../../redux/actions/loginActions';
import { toast } from "react-toastify";
import decode from 'jwt-decode';
import './header.css';

const Header = ({ logout }) => {

    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const location = useLocation();
    const history = useHistory();
    const handleLogoutClick = () => {
        logout()
        setUser(null);
        localStorage.clear()
        history.push('/')
        toast.success('Successfully logged out')
    }

    useEffect(() => {
        // checking for JWT token expiration
        if (user && user.token) {
            const decodedToken = decode(user.token);
            if (decodedToken.exp * 1000 < new Date().getTime()) {
                logout()
                setUser(null);
                localStorage.clear()
            }
        }

        setUser(JSON.parse(localStorage.getItem('profile')))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        <header className='header--wrapper'>
            <div className='header--container'>
                <div className='header__logo'>
                    <NavLink to='/'>
                        <img src='https://res.cloudinary.com/dvjsq7rnx/image/upload/v1621615874/benchmark/essentials/oe8xhu61q7zkucwcxzms.jpg' alt='Benchmark homepage logo' /> <span className='header__logo--text'>Benchmark</span>
                    </NavLink>
                </div>
                <nav>
                    <ul>
                        {user ?
                            <>
                                <li>
                                    <NavLink to={'/profile/' + user.result._id}>
                                        <img className='user--image' src={user.result.image ? user.result.image.secure_url : user.result.imageUrl} alt={user.result.name + "'s profile image"} />
                                        <p className='user--name'>{user.result.name}</p>
                                    </NavLink>
                                </li>
                                |
                                <li>
                                    <button onClick={() => handleLogoutClick()}>
                                        Logout
                                    </button>
                                </li>
                                |
                                <li>
                                    <NavLink to='/post/new'>
                                        New Post
                                </NavLink>
                                </li>
                            </>
                            : <>
                                <li>
                                    <NavLink to='/login'>
                                        Login/Register
                                    </NavLink>
                                </li>
                            </>
                        }

                    </ul>
                </nav>
            </div>
        </header>
    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    logout
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
